<script lang="ts">
    import GtmScript from './GtmScript.svelte';
    import TrustArc from './TrustArc.svelte';

    let trustArcScriptLoaded: boolean;
</script>

<TrustArc bind:trustArcScriptLoaded implied privacypolicylink="/cookies-notice" />
{#if trustArcScriptLoaded}
    <GtmScript />
{/if}
